import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import CardHeader from '@material-ui/core/CardHeader';
import Hidden from '@material-ui/core/Hidden';

import ListItemRow from '../../ListItemRow/ListItemRow';
import IndentedCardHeader from '../../IndentedCardHeader/IndentedCardHeader.js';
import IndentedCardContent from '../../IndentedCardContent/IndentedCardContent.js';
import ViewMoreLink from '../../ViewMoreLink/ViewMoreLink';

import {
  getString,
  stringToDayName,
  stringToDay,
  stringToMonth,
  stringToYear,
} from '../../../helpers/stringHelpers.js';

import styles from './styles.js';

const stringsComponent = 'appointments';

class AppointmentSummaryCard extends React.Component {
  render() {
    const {
      classes,
      title,
      date,
      timeFrom,
      timeTo,
      description,
      helpText,
      action,
    } = this.props;

    const body = (
      <div className={classes.negativeTopMargin}>
        <Divider />
        <ListItemRow
          className={classes.listItem}
          primaryLabel=''
          secondaryLabel={
            <span className={classes.details}>
              {timeFrom} - {timeTo} | {date}
            </span>
          }
          primaryValue={
            action ? (
              <div className={classes.viewMoreLinkWrapper}>
                <ViewMoreLink
                  action={action}
                  label={getString(stringsComponent, 'VIEW_DETAILS_LABEL')}
                />
              </div>
            ) : null
          }
        />
        <Typography className={classes.subtitle}>{description}</Typography>
      </div>
    );

    return (
      <div className={classes.root}>
        <Card className={`Card ${classes.appointmentCard}`}>
          <CardHeader
            title={
              <div>
                <Typography variant='h3' className={classes.cardTitleLarge}>
                  {title}
                </Typography>
              </div>
            }
            avatar={
              <div>
                <div className={classes.calendarTop}>
                  <Typography className={classes.dayName}>
                    {stringToDayName(date)}
                  </Typography>
                </div>
                <div className={classes.calendarBottom}>
                  <Typography className={classes.day}>
                    {stringToDay(date)}
                  </Typography>
                  <Typography className={classes.monthYear}>
                    {stringToMonth(date)}
                  </Typography>
                </div>
              </div>
            }
            className='CardHeader'
            classes={{
              root: classes.cardHeader,
              title: `${classes.title} CardHeaderTitle`,
              content: classes.headerContent,
              avatar: `${classes.avatar} CardIcon`,
            }}
          />
          <IndentedCardContent body={body} helpText={helpText} />
        </Card>
      </div>
    );
  }
}

AppointmentSummaryCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  timeFrom: PropTypes.string.isRequired,
  timeTo: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  action: PropTypes.func,
};

AppointmentSummaryCard.defaultProps = {
  helpText: null,
  action: null,
};

export default withStyles(styles)(AppointmentSummaryCard);
